<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('rounds')" class="col-sm-4 col-form-label">Rounds</label>
        <div class="col-sm-8">
          <input type="number" class="form-control" :id="safeId('rounds')" v-model.lazy="rounds">
        </div>
      </div>
      <table-edit :cols="columnDefinitions" :rows="records"></table-edit>
    </window-tab>
    <window-tab title="Data" icon="database">
      <album-select-group v-model="albumId"></album-select-group>
      <div class="form-group row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group row" v-for="(v, k) in columnDefinitions" :key="k">
        <label :for="safeId(k)" class="col-sm-4 col-form-label">{{ v }}</label>
        <div class="col-sm-8">
          <column-select :id="safeId(k)" :value="columnMap[k]" @input="val => {
            columnMap[k] = val
            columnMap = columnMap
          }" :dataset-id="datasetId"></column-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateData } from '@/utils'
  import * as action from '@/store/action-types'

  export default {
    name: 'knockout',
    mixins: [templateMixin],
    data () {
      return {
        columnDefinitions: {
          'round': 'Runde',
          'group': 'Group',
          'bibNumber': 'Startnummer',
          'lastName': 'Nachname',
          'firstName': 'Vorname',
          'country': 'Country',
          'rank': 'Rang',
          'score': 'Wertung'
        }
      }
    },
    computed: {
      ...mapOverlayData(['title', 'rounds']),
      ...mapOverlayData({'records': {default: []}}),
      ...mapTemplateData(['albumId', 'datasetId']),
      ...mapTemplateData({columnMap: {default: {}}}),
      records () {
        const dataset = this.$store.getters.dataset(this.datasetId)
        if (!dataset) return []
        return dataset.records.map(record => {
          return this.mapRecord(record, this.columnMap)
        })
      }
    },
    watch: {
      records: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {records: val}
        })
      },
      albumId: function (val) {
        const album = this.$store.getters.album(this.albumId) || {}
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {sponsors: album.pictures}
        })
      }
    },
    methods: {
      mapRecord (record, columnMap) {
        return Object.keys(columnMap).reduce((result, key) => {
          result[key] = record[columnMap[key]]
          return result
        }, {})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/knockout.vue